import { FormWizardProps } from '@hb/shared-frontend/components/forms/FormWizard/types'
import { InsuranceInfoStage } from './insuranceInfo/InsuranceInfoStage'

export const renderStage: FormWizardProps['renderStage'] = {
  insuranceInfo: InsuranceInfoStage,
}
